/**
 * Available tracking events for application events, like vacancy applications, new scouted candidate.
 */
 export enum AnalyticsAppEvents {
    AppliedToVacancy = 'ApppliedToVacancy',
    ApplyThroughMessengerBtnClicked = 'ApplyThroughMessengerBtn.Clicked'
  }
  